import { adminPageSlice } from './admin.slice.ts';

export const { UPDATE_STATE_STATUS, UPDATE_STATION_SETTINGS, UPDATE_NEW_ENTRY } =
  adminPageSlice.actions;
